import { createFileRoute } from '@tanstack/react-router';

import { requireAnon } from '@/router/guards';
import Login from '@/ui/pages/Login/Login';

export interface LoginSearch {
  readonly redirect?: string | undefined;
}

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  beforeLoad: ({ context }) => {
    requireAnon(context);
  },
  component: Login,
});
